<template>
  <Admin>
    <v-main v-if="false">
      <div
        class="tw-container tw-mx-auto fit-screen-div tw-overflow-hidden tw-flex tw-items-center tw-justify-center tw-text-center"
      >
        <div>
          <img src="/images/icons/db-connection.svg" class="mx-auto" />
          <b class="tw-pt-5 tw-max-w-lg tw-mx-auto add-margin-10">
            คุณยังไม่ได้ตั้งค่าเพื่อเชื่อมต่อกับ e-commerce
          </b>
          <p class="add-margin-10">
            คลิกที่ปุ่มเชื่อมต่อด้านล่างเพื่อเปิดใช้งานใบสั่งขายออนไลน์
          </p>
          <button class="connect-button add-margin-10">
            เชื่อมต่อกับ e-commerce
          </button>
        </div>
      </div>
    </v-main>
    <v-main v-if="true">
      <v-container fluid>
        <v-row justify="center">
          <v-col>
            <document-table></document-table>
          </v-col>
        </v-row>
        <v-row justify="start">
          <v-col>
            <pagination collection-name="saleorders"></pagination>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </Admin>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Admin from "../../components/admin/admin-main-template";
import DocumentTable from "../../components/admin/documents/table.saleorders";
import Pagination from "../../components/admin/pagination";

export default {
  name: "Document",
  components: {
    Admin,
    DocumentTable,
    Pagination,
  },
  computed: mapState({
    docs: (state) => state.saleorders.list,
    keyword: (state) => state.saleorders.keyword,
  }),
  methods: {
    ...mapActions({
      resetKeyword: "saleorders/resetKeyword",
    }),
  },
  beforeRouteLeave(to, from, next) {
    // console.log("current", from.path, '->', to.path);
    this.resetKeyword();
    next();
  },
};
</script>
<style lang="scss">
.fit-screen-div {
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  position: absolute;
}
.connect-button {
  // display: flex;
  flex-direction: row;
  // align-items: flex-start;
  padding: 8px 20px 9px;
  background: #619fd4;
  border-radius: 4px;
  color: #ffffff;
}
.add-margin-10 {
  margin: 10px;
}
</style>
